export class LoanInterestRates {
    ID:number;
CLIENT_ID:number;
TYPE_NAME:string;
DURATION:string;
INTEREST_RATE:string;
SEQUENCE_NO:number;
STATUS:boolean=true;

}